import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { AgremoAnalysisStatus } from '../data-models/agremo-analysis-status.model';
import { AgremoAnalysis } from '../data-models/agremo-analysis.model';
import { Page } from '../response-models/page.model';

/** Query for one organization's analyses. The hub's org route reads only `status`, `page` and `limit`. */
export interface OrganizationAgremoAnalysisQuery {
  page?: number;
  limit?: number;
  status?: AgremoAnalysisStatus | 'all';
}

/**
 * One organization's Agremo analyses: `/admin/organizations/:id/agremo/analyses`
 * (hub `AdminAgremoOrgAnalysesController`), paged with `limit`.
 */
@Injectable({ providedIn: 'root' })
export class OrganizationAgremoAnalysisService extends BaseService<AgremoAnalysis> {
  constructor() {
    super('agremo/analyses', AgremoAnalysis);
  }

  /** GET /admin/organizations/:organizationId/agremo/analyses */
  listOrganizationAnalyses(organizationId: string, query: OrganizationAgremoAnalysisQuery = {}): Observable<Page<AgremoAnalysis>> {
    const status = query.status && query.status !== 'all' ? query.status : undefined;
    return this.getPage({ prefix: ['admin', 'organizations', organizationId], query: { page: query.page, limit: query.limit, status } });
  }
}
